// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.action-container {
  width: 100%;
}

.section-header {
  font-weight: 600;
}

.error-list-container {
  margin: 12px 0;
  max-height: 350px;
  overflow: auto;
}

:host .mdc-button {
  min-width: unset !important;
}

::ng-deep .mat-mdc-button .mat-mdc-button-persistent-ripple::before {
  --mat-text-button-state-layer-color: #fff;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/dialogs/error/error.component.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;AACF;;AAEA;EACE,gBAAA;AACF;;AAEA;EACE,cAAA;EACA,iBAAA;EACA,cAAA;AACF;;AAEA;EACE,2BAAA;AACF;;AAEA;EACE,yCAAA;AACF","sourcesContent":[".action-container {\n  width: 100%;\n}\n\n.section-header {\n  font-weight: 600;\n}\n\n.error-list-container {\n  margin: 12px 0;\n  max-height: 350px;\n  overflow: auto;\n}\n\n:host .mdc-button {\n  min-width: unset !important\n}\n\n::ng-deep .mat-mdc-button .mat-mdc-button-persistent-ripple::before {\n  --mat-text-button-state-layer-color: #fff;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
